import { Control, Field, Input } from "@allxsmith/bestax-bulma";
import React from "react";
import useInlineEditButton from "./useInlineEditButton";

function useEditableTableCostCell({
  propName,
  value,
  onChange,
  onSave,
  editable,
  setEditable,
  disabled,
  inlineEdit,
  className
}) {
  const input = (
    <td onClick={e => e.stopPropagation()}>
      <Field className="has-addons">
        <Control>
          <Input
            onChange={onChange}
            className={className ? className : "small-row-black"}
            type={editable ? "number" : "text"}
            name={propName}
            value={
              editable
                ? value
                : (parseFloat(value) || 0).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })
            }
            disabled={!editable}
          />
        </Control>
        {useInlineEditButton({show: inlineEdit, onSave, setEditable, editable, disabled})}
      </Field>
    </td>
  );
  return input;
}

export default useEditableTableCostCell;
